import ColorfulRcForm from './colorful-rcForm';
export default ColorfulRcForm;
